<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('售后单编号')" prop="id">
                <a-input v-model="queryParam.id" @pressEnter="handleQuery" :maxLength="20" :placeholder="$t('请输入')+$t('售后单编号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('原订单编号')" prop="oriOrderId">
                <a-input v-model="queryParam.oriOrderId" @pressEnter="handleQuery" :maxLength="20"  :placeholder="$t('请输入')+$t('原订单编号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('售后状态')" prop="refundStatus">
                <a-select  mode="multiple" :placeholder="$t('请选择')+$t('售后状态')"
                           @change="refundStatusListChange"
                           style="width: 100%" v-model="queryParam.refundStatusList" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.OrderRefundStatusEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('售后类型')" prop="refundType">
                  <a-select  :placeholder="$t('请选择')+$t('售后类型')" style="width: 100%" v-model="queryParam.refundType" allowClear>
                    <a-select-option v-for="(item, index) in this.customDict.GoodsRefundTypeEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('申请开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                                 :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('申请结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                                 :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('售后原因')" prop="reason">
                  <a-select :placeholder="$t('请选择')+$t('售后原因')" style="width: 100%" v-model="queryParam.reason" allowClear>
                    <a-select-option v-for="(item, index) in this.cancelCauseList" :value="item.id" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <a-tabs v-model="activeKey" @tabClick="changeTab">
        <a-tab-pane key="" :tab="$t('全部订单')"/>
        <a-tab-pane v-for="pane in this.customDict.OrderRefundStatusEnum" :key="pane.type" :tab="pane.name">
        </a-tab-pane>
      </a-tabs>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="multiple || !getAudit()" @click="$refs.auditForm.handleAudit(undefined,ids)" v-hasPermi="['order:refund:audit']">
          <a-icon type="download" />{{$t('审核')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['order:refund:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <a-button type="primary" :disabled="multiple"  @click="handleSelectExport" v-hasPermi="['order:refund:export']">
          <a-icon type="download" />{{$t('选中导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <detail-form
        ref="detailForm"
        @ok="getList"
      />
      <!-- 增加修改 -->
      <normal-detail-form ref="normalDetailForm"/>
      <uniform-detail-form ref="uniformDetailForm"/>
      <score-detail-form ref="scoreDetailForm"/>

      <audit-form
        ref="auditForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: '130%' }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="oriOrderId" slot-scope="text, record">
          <a v-if="record.orderType ===20 " @click="$refs.normalDetailForm.handleDetail(record.oriOrderId)">{{record.oriOrderId}}</a>
          <a v-if="record.orderType ===21 " @click="$refs.uniformDetailForm.handleDetail(record.oriOrderId)">{{record.oriOrderId}}</a>
          <a v-if="record.orderType ===22 " @click="$refs.scoreDetailForm.handleDetail(record.oriOrderId)">{{record.oriOrderId}}</a>

        </span>
        <template slot="refundPicList" slot-scope="text, record">
          <img v-for="(item) in record.refundPicList" :src="item"  style="width:60px;height:62px;" @click="handleRecordPreview(item)" alt="none">
        </template>
        <div slot="goodsTitle" style="width: 400px">
          <a-row>
            {{$t('商品信息')}}
          </a-row>
          <a-row>
            <a-col :span="12">{{$t('商品名称')}}</a-col>
            <a-col :span="6">{{$t('商品主图')}}</a-col>
            <a-col :span="6">{{$t('售后数量')}}</a-col>
          </a-row>
        </div>
        <div slot="orderItemList"  slot-scope="text, record">
          <a-table class="innerTable" :showHeader="false" size="small" :bordered="false"  rowKey="orderItemId"
                   :pagination="false" :columns="goodsColumns" :data-source="record.orderItemList">
            <template slot="picture" slot-scope="text, record">
              <div>
                <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
              </div>
            </template>
          </a-table>
        </div>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
            <a @click="$refs.detailForm.handleDetail(record.id)">
              <a-icon type="eye" />{{$t('详情')}}
            </a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <a-icon type="double-right" />
              {{$t('更多')}}
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['order:refund:audit']" v-if="record.refundStatus===5010">
                <a @click="$refs.auditForm.handleAudit(record.id,undefined)"  v-hasPermi="['order:refund:audit']">
                  <a-icon type="edit" />{{$t('审核')}}
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['order:refund:audit']" v-if="record.refundStatus===5030">
                <a @click="handleDeliveryRefuse(record.id)"  v-hasPermi="['order:refund:audit']">
                  <a-icon type="edit" />拒绝收货
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['order:refund:audit']" v-if="record.refundStatus===5030">
                <a @click="handleReceipt(record.id)"  v-hasPermi="['order:refund:audit']">
                  <a-icon type="edit" />收货并退款
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageRefund, listRefund, delRefund, refundReceipt, auditRefund} from '@/api/order/refund'
import {listCancelCause} from '@/api/order/cancelCause'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import DetailForm from './modules/detailForm'
import NormalDetailForm from '../sell/modules/NormalDetailForm.vue'
import UniformDetailForm from '../sell/modules/UniformDetailForm.vue'
import ScoreDetailForm from '../sell/modules/ScoreDetailForm.vue'

import AuditForm from './modules/AuditForm'

import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Refund',
  components: {
    DetailForm,
    AuditForm,
    NormalDetailForm,
    UniformDetailForm,
    ScoreDetailForm,
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      activeKey: null,
      pageSizeOptions: [ '10', '20', '50','100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      cancelCauseList:[],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        refundType: undefined,
        oriOrderId: undefined,
        type: undefined,
        submitUserId: undefined,
        userId: undefined,
        shopId: undefined,
        refundStatus: undefined,
        refundStatusList: [],
        refundAmount: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        isRefundOnly: undefined,
        isReceipt: undefined,
        reason: undefined,
        refundPic: undefined,
        isDisplay: undefined,
        pageNum: 1,
        pageSize: 10
      },
      goodsColumns:[
        {
          dataIndex: 'goodsName',
          width:200,
          align: 'center',
        },
        {
          dataIndex: 'picture',
          width:100,
          scopedSlots: {customRender: 'picture'},
          align: 'center'
        },
        {
          width:100,
          dataIndex: 'refundCount',
          align: 'center'
        },
      ],
      columns: [
        {
          title: this.$t('售后单编号'),
          dataIndex: 'id',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center',
          width: 200,
          fixed: 'left',
        },
        {
          title: this.$t('原订单编号'),
          dataIndex: 'oriOrderId',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'oriOrderId' },
          align: 'center',
          width: 200,
          fixed: 'left',
        },
        {
          title: this.$t('售后状态'),
          dataIndex: 'refundStatusName',
          align: 'center'
        },
        {
          title: this.$t('退款金额'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'refundAmount',
          align: 'center'
        },
        {
          width: 400,
          dataIndex: 'orderItemList',
          scopedSlots: { customRender: 'orderItemList' },
          slots: { title: 'goodsTitle' },
          align: 'center'
        },
        {
          title: this.$t('售后类型'),
          dataIndex: 'refundTypeName',
          align: 'center'
        },
        {
          title: this.$t('售后原因'),
          dataIndex: 'reasonName',
          align: 'center'
        },
        {
          title: this.$t('售后凭证'),
          scopedSlots: { customRender: 'refundPicList' },
          dataIndex: 'refundPicList',
          align: 'center'
        },
        {
          title: this.$t('申请时间'),
          dataIndex: 'createTime',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          fixed: 'right',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getCancelCauseList()
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    $route: 'getRefundRouteList',
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    refundStatusListChange() {
      this.queryParam.refundStatus = undefined;
    },
    changeTab(index) {
      if (index == null) {
        index = undefined;
      }
      this.queryParam.refundStatus = index;
      this.getList();
    },
    getRefundRouteList() {
      let params = this.$route.params;
      console.log('退款params',params)
      if (params) {
        for (let key in params) {
          if (this.queryParam.hasOwnProperty(key)) {
            this.queryParam[key] = params[key];
          }
        }
      }
      this.getList();
    },
    /** 查询售后订单列表 */
    getList () {
      this.loading = true
     pageRefund(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    getCancelCauseList () {
      let queryParam = {type:2}
      listCancelCause(queryParam).then(response => {
        this.cancelCauseList = response.data
      })
    },

    getAudit() {
      if (this.queryParam.refundStatus === 5010) {
        return true;
      } else {
        console.log('有refundStatus',this.queryParam.refundStatusList)
        return this.queryParam.refundStatusList.includes(5010);
      }
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        id:undefined,
        refundType:undefined,
        oriOrderId: undefined,
        type: undefined,
        submitUserId: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        userId: undefined,
        shopId: undefined,
        refundStatus: undefined,
        refundStatusList: [],
        refundAmount: undefined,
        isRefundOnly: undefined,
        isReceipt: undefined,
        reason: undefined,
        refundPic: undefined,
        isDisplay: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc';
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delRefund(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    handleReceipt(id) {
      let that = this
      let form = {"id":id }
      this.$confirm({
        title: this.$t('是否确认退款'),
        content: '此操作将确认收货,并退款',
        onOk () {
          refundReceipt(form).then(resp => {
            if (resp.code==='20001') {
              that.$message.success('退款成功', 3);
              that.getList()
            }
          });
        },
        onCancel () {}
      })
    },
    handleDeliveryRefuse(id) {
      let that = this
      let form = {"id":id,"isPass":false }
      this.$confirm({
        title: this.$t('是否确认拒绝'),
        onOk () {
          auditRefund(form).then(resp => {
            if (resp.code==='20001') {
              that.$message.success('拒绝成功', 3);
              that.getList()
            }
          });
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/order/refund/export',
            that.queryParam
          , `售后订单_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出选中数据'),
        onOk () {
          that.download('biz/admin/order/refund/export', queryParam, `售后订单_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple=true
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple=true
          that.selectedRowKeys=[]
        }
      })
    }
  }
}
</script>
<style>
.innerTable {
  border: none !important;
}

.innerTable .ant-table,
.innerTable .ant-table-container,
.innerTable .ant-table-thead > tr > th,
.innerTable .ant-table-tbody > tr > td {
  border: none !important;
}
</style>
